/* Stories de l'accueil : lecteur vidéo plein écran (code écrit pour ce thème, mesures relevées sur lancaster.com).
   - clic sur une vignette : ouverture du lecteur, lecture muette (playsinline), barre de progression
   - fin d'une vidéo : passage automatique à la suivante (fermeture après la dernière)
   - précédent / suivant / début / fin, pause, son, croix, Échap, flèches du clavier, clic hors du lecteur
   - carte produit : « Ajouter au panier » ajoute la variante par défaut puis ouvre le tiroir panier */
(function () {
  if (window.__lcStories) return;
  window.__lcStories = true;

  var ICON = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4.5v15l12.5-7.5z"/></svg>',
    sound: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9.5v5h4l5 4.5v-14L7 9.5z"/><path d="M15 8.5a5 5 0 010 7M17.5 5.5a9 9 0 010 13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    muted: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9.5v5h4l5 4.5v-14L7 9.5z"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    edge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 5v14M20 5l-10 7 10 7z"/></svg>',
    bag: '<svg viewBox="0 0 20 21" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.31543C8.51804 2.31543 7.31667 3.5168 7.31667 4.99876V5.41543H5.75C4.64543 5.41543 3.75 6.31086 3.75 7.41543V16.7488C3.75 17.8533 4.64543 18.7488 5.75 18.7488H14.25C15.3546 18.7488 16.25 17.8533 16.25 16.7488V7.41543C16.25 6.31086 15.3546 5.41543 14.25 5.41543H12.6833V4.99876C12.6833 3.5168 11.482 2.31543 10 2.31543ZM11.4833 6.61543V7.35987V9.5821C11.4833 9.91347 11.752 10.1821 12.0833 10.1821C12.4147 10.1821 12.6833 9.91347 12.6833 9.5821V7.35987V6.61543H14.25C14.6918 6.61543 15.05 6.9736 15.05 7.41543V16.7488C15.05 17.1906 14.6918 17.5488 14.25 17.5488H5.75C5.30817 17.5488 4.95 17.1906 4.95 16.7488V7.41543C4.95 6.9736 5.30817 6.61543 5.75 6.61543H7.31667V7.35987V9.5821C7.31667 9.91347 7.5853 10.1821 7.91667 10.1821C8.24804 10.1821 8.51667 9.91347 8.51667 9.5821V7.35987V6.61543H11.4833ZM11.4833 5.41543V4.99876C11.4833 4.17954 10.8192 3.51543 10 3.51543C9.18078 3.51543 8.51667 4.17954 8.51667 4.99876V5.41543H11.4833Z" fill="#000"/></svg>',
  };

  /* source mp4 la plus légère d'au moins 720 px de haut (sinon la plus haute), jamais au-delà de 720 si 720 existe */
  function pick(it) {
    var s = (it.sources || []).filter(function (x) { return x.h > 0; });
    var ok = s.filter(function (x) { return x.h >= 720 && x.h <= 720; });
    if (ok.length) return ok[0].url;
    s.sort(function (a, b) { return Math.abs(a.h - 720) - Math.abs(b.h - 720); });
    return s.length ? s[0].url : it.sources[it.sources.length - 1].url;
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  function Player(items) {
    this.items = items;
    this.index = 0;
    this.lastFocus = null;
    this.build();
  }

  Player.prototype.build = function () {
    var self = this;
    var root = (this.root = el('div', 'lc-sp'));
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Stories');
    root.innerHTML =
      '<div class="lc-sp__nav lc-sp__nav--prev">' +
        '<button type="button" class="lc-sp__navbtn lc-sp__navbtn--edge" data-act="first" aria-label="Première story">' + ICON.edge + '</button>' +
        '<button type="button" class="lc-sp__navbtn lc-sp__navbtn--chapter" data-act="prev" aria-label="Story précédente">' + ICON.chevron + '</button>' +
      '</div>' +
      '<div class="lc-sp__player">' +
        '<video class="lc-sp__video" playsinline muted preload="metadata" webkit-playsinline></video>' +
        '<span class="lc-sp__loader" aria-hidden="true"></span>' +
        '<div class="lc-sp__bar" aria-hidden="true"><span class="lc-sp__bar-fill"></span></div>' +
        '<button type="button" class="lc-sp__tap lc-sp__tap--prev" data-act="prev" aria-label="Story précédente" tabindex="-1"></button>' +
        '<button type="button" class="lc-sp__tap lc-sp__tap--next" data-act="next" aria-label="Story suivante" tabindex="-1"></button>' +
        '<div class="lc-sp__head">' +
          '<div class="lc-sp__who"><img class="lc-sp__avatar" alt=""><h2 class="lc-sp__name"></h2></div>' +
          '<button type="button" class="lc-sp__close" data-act="close" aria-label="Fermer les stories">' + ICON.close + '</button>' +
          '<div class="lc-sp__actions">' +
            '<button type="button" class="lc-sp__action" data-act="pause" aria-pressed="false" aria-label="Mettre la story en pause"><span class="is-on">' + ICON.pause + '</span><span class="is-off">' + ICON.play + '</span></button>' +
            '<button type="button" class="lc-sp__action" data-act="mute" aria-pressed="true" aria-label="Activer le son"><span class="is-on">' + ICON.sound + '</span><span class="is-off">' + ICON.muted + '</span></button>' +
          '</div>' +
        '</div>' +
        '<div class="lc-sp__card">' +
          '<img class="lc-sp__card-img" alt="">' +
          '<div class="lc-sp__card-body">' +
            '<div class="lc-sp__card-text"><p class="lc-sp__card-title"></p><p class="lc-sp__card-sub"></p></div>' +
            '<button type="button" class="lc-sp__buy" data-act="buy">' + ICON.bag + '<span class="lc-sp__buy-label">Ajouter au panier</span></button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="lc-sp__nav lc-sp__nav--next">' +
        '<button type="button" class="lc-sp__navbtn lc-sp__navbtn--chapter lc-sp__navbtn--next" data-act="next" aria-label="Story suivante">' + ICON.chevron + '</button>' +
        '<button type="button" class="lc-sp__navbtn lc-sp__navbtn--edge lc-sp__navbtn--next" data-act="last" aria-label="Dernière story">' + ICON.edge + '</button>' +
      '</div>';
    document.body.appendChild(root);

    var q = function (s) { return root.querySelector(s); };
    this.video = q('.lc-sp__video');
    this.fill = q('.lc-sp__bar-fill');
    this.avatar = q('.lc-sp__avatar');
    this.name = q('.lc-sp__name');
    this.cardImg = q('.lc-sp__card-img');
    this.cardTitle = q('.lc-sp__card-title');
    this.cardSub = q('.lc-sp__card-sub');
    this.buy = q('.lc-sp__buy');
    this.buyLabel = q('.lc-sp__buy-label');
    this.pauseBtn = q('[data-act="pause"]');
    this.muteBtn = q('[data-act="mute"]');
    this.card = q('.lc-sp__card');
    this.video.muted = true;

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (b) { self.act(b.getAttribute('data-act')); return; }
      // image ou titre de la carte produit : fiche produit de la story en cours
      if (e.target.closest('.lc-sp__card-img, .lc-sp__card-title')) { self.openProduct(); return; }
      if (!e.target.closest('.lc-sp__player, .lc-sp__nav')) self.close();
    });
    // un toucher sur la vidéo : pause / lecture (comme le lecteur d'origine)
    this.video.addEventListener('click', function () { self.toggle(); });
    this.video.addEventListener('timeupdate', function () {
      var d = self.video.duration;
      if (d > 0) self.fill.style.transform = 'scaleX(' + Math.min(1, self.video.currentTime / d) + ')';
    });
    this.video.addEventListener('ended', function () { self.next(true); });
    this.video.addEventListener('waiting', function () { root.classList.add('is-loading'); });
    this.video.addEventListener('playing', function () { root.classList.remove('is-loading'); });
    this.video.addEventListener('canplay', function () { root.classList.remove('is-loading'); });
    this.video.addEventListener('pause', function () { if (!self.video.ended) self.syncPause(); });
    this.video.addEventListener('play', function () { self.syncPause(); });
    this.onKey = function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); self.close(); }
      else if (e.key === 'ArrowRight') self.next(false);
      else if (e.key === 'ArrowLeft') self.prev();
      else if (e.key === 'Tab') self.trap(e);
    };
    document.addEventListener('keydown', this.onKey);

    // balayage horizontal sur mobile
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 60) { dx < 0 ? self.next(false) : self.prev(); }
    }, { passive: true });
  };

  Player.prototype.openProduct = function () {
    var it = this.items[this.index];
    if (it && it.url) window.location.href = it.url;
  };

  Player.prototype.trap = function (e) {
    var f = Array.prototype.filter.call(this.root.querySelectorAll('button:not([disabled]):not([tabindex="-1"])'), function (b) { return b.offsetParent !== null || b === document.activeElement; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Player.prototype.syncPause = function () {
    var paused = this.video.paused;
    this.pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    this.pauseBtn.setAttribute('aria-label', paused ? 'Reprendre la story' : 'Mettre la story en pause');
  };

  Player.prototype.show = function (i) {
    var it = this.items[i];
    if (!it) return;
    this.index = i;
    var v = this.video;
    this.root.classList.add('is-loading');
    this.fill.style.transform = 'scaleX(0)';
    v.poster = it.poster || '';
    v.src = pick(it);
    v.muted = this.muteBtn.getAttribute('aria-pressed') === 'true';
    this.avatar.src = it.avatar || it.poster || '';
    this.name.textContent = it.title;
    this.cardImg.src = it.image || it.poster || '';
    this.cardTitle.textContent = it.title;
    this.cardSub.textContent = it.subtitle || '';
    this.buy.disabled = !it.available;
    this.buy.classList.remove('is-done');
    this.buyLabel.textContent = it.available ? 'Ajouter au panier' : 'Épuisé';
    // la carte réapparaît en fondu à chaque vidéo
    this.card.style.animation = 'none';
    void this.card.offsetWidth;
    this.card.style.animation = '';
    var last = this.items.length - 1;
    var set = function (sel, off) { this.root.querySelectorAll(sel).forEach(function (b) { b.disabled = off; }); }.bind(this);
    set('[data-act="prev"].lc-sp__navbtn, [data-act="first"]', i === 0);
    set('[data-act="next"].lc-sp__navbtn, [data-act="last"]', i === last);
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* lecture bloquée : le bouton lecture reprend */ });
    this.syncPause();
  };

  Player.prototype.open = function (i, opener) {
    this.lastFocus = opener || document.activeElement;
    document.body.classList.add('lc-sp-lock');
    this.root.classList.add('is-open');
    this.show(i);
    var c = this.root.querySelector('.lc-sp__close');
    if (c) c.focus({ preventScroll: true });
  };

  Player.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.load();
    document.body.classList.remove('lc-sp-lock');
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
  };

  Player.prototype.next = function (auto) {
    if (this.index < this.items.length - 1) this.show(this.index + 1);
    else if (auto) this.close();
  };
  Player.prototype.prev = function () {
    if (this.video.currentTime > 2) { this.video.currentTime = 0; return; }
    if (this.index > 0) this.show(this.index - 1);
    else this.video.currentTime = 0;
  };
  Player.prototype.toggle = function () {
    if (this.video.paused) { var p = this.video.play(); if (p && p.catch) p.catch(function () {}); } else this.video.pause();
  };

  Player.prototype.act = function (a) {
    if (a === 'close') this.close();
    else if (a === 'next') this.next(false);
    else if (a === 'prev') this.prev();
    else if (a === 'first') this.show(0);
    else if (a === 'last') this.show(this.items.length - 1);
    else if (a === 'pause') this.toggle();
    else if (a === 'mute') {
      var on = this.muteBtn.getAttribute('aria-pressed') !== 'true';
      this.muteBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      this.muteBtn.setAttribute('aria-label', on ? 'Activer le son' : 'Couper le son');
      this.video.muted = on;
    } else if (a === 'buy') this.addToCart();
  };

  Player.prototype.addToCart = async function () {
    var it = this.items[this.index];
    if (!it || !it.available || this.buy.disabled) return;
    var self = this;
    this.buy.disabled = true;
    try {
      var preview = {
        title: it.title, variantTitle: it.variantTitle, image: it.image, price: it.price, url: it.url + '?variant=' + it.variantId
      };
      if (window.ValeraneCart && typeof window.ValeraneCart.add === 'function') {
        await window.ValeraneCart.add({ id: it.variantId, quantity: 1, properties: {}, preview: preview });
      } else {
        var body = new FormData();
        body.set('id', it.variantId);
        body.set('quantity', '1');
        var res = await fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body
        });
        var json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || 'Ajout impossible');
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }
      this.buy.classList.add('is-done');
      // le tiroir panier s'ouvre au-dessus : on met la story en pause et on la ferme
      this.close();
    } catch (err) {
      this.buyLabel.textContent = 'Réessayer';
      if (window.console) console.warn('[stories] ajout au panier impossible', err);
    } finally {
      this.buy.disabled = !it.available;
    }
  };

  function init(root) {
    if (root.__lcStories) return;
    var holder = root.querySelector('[data-lc-stories-data]');
    if (!holder) return;
    var items;
    try { items = JSON.parse(holder.textContent); } catch (e) { return; }
    if (!items.length) return;
    root.__lcStories = true;
    var player = null;
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lc-story]');
      if (!b) return;
      var idx = Number(b.getAttribute('data-lc-story'));
      var pos = 0;
      for (var k = 0; k < items.length; k++) if (items[k].index === idx) pos = k;
      if (!player) player = new Player(items);
      player.open(pos, b);
    });
  }

  function scan() { document.querySelectorAll('[data-lc-stories]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
